"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return OutlineEdit;
    }
});
var _react = /*#__PURE__*/ _interopRequireWildcard(require("react"));
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) {
        return obj;
    }
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
        return {
            default: obj
        };
    }
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) {
        return cache.get(obj);
    }
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj){
        if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
            var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
            if (desc && (desc.get || desc.set)) {
                Object.defineProperty(newObj, key, desc);
            } else {
                newObj[key] = obj[key];
            }
        }
    }
    newObj.default = obj;
    if (cache) {
        cache.set(obj, newObj);
    }
    return newObj;
}
function OutlineEdit(props) {
    return /*#__PURE__*/ _react.createElement("svg", _extends({
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props), /*#__PURE__*/ _react.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M3.27487 20.7253L3.92131 17.4931L14.0001 7.41429L16.5859 10.0001L6.5071 20.0789L3.27487 20.7253ZM18.0001 8.58586L20.5859 6.00008L18.0001 3.41429L15.4143 6.00008L18.0001 8.58586ZM17.293 1.29297L2.29301 16.293L2.01953 16.804L1.01953 21.804L2.19623 22.9807L7.19623 21.9807L7.70722 21.7072L22.7072 6.70718V5.29297L18.7072 1.29297H17.293Z",
        fill: "white"
    }), /*#__PURE__*/ _react.createElement("path", {
        d: "M9.5 3C9.40054 3 9.30516 2.96049 9.23483 2.89017C9.16451 2.81984 9.125 2.72446 9.125 2.625C9.125 2.42609 9.04598 2.23532 8.90533 2.09467C8.76468 1.95402 8.57391 1.875 8.375 1.875C8.27554 1.875 8.18016 1.83549 8.10983 1.76517C8.03951 1.69484 8 1.59946 8 1.5C8 1.40054 8.03951 1.30516 8.10983 1.23483C8.18016 1.16451 8.27554 1.125 8.375 1.125C8.57391 1.125 8.76468 1.04598 8.90533 0.90533C9.04598 0.764678 9.125 0.573912 9.125 0.375C9.125 0.275544 9.16451 0.180161 9.23483 0.109835C9.30516 0.0395088 9.40054 0 9.5 0C9.59946 0 9.69484 0.0395088 9.76517 0.109835C9.83549 0.180161 9.875 0.275544 9.875 0.375C9.875 0.573912 9.95402 0.764678 10.0947 0.90533C10.2353 1.04598 10.4261 1.125 10.625 1.125C10.7245 1.125 10.8198 1.16451 10.8902 1.23483C10.9605 1.30516 11 1.40054 11 1.5C11 1.59946 10.9605 1.69484 10.8902 1.76517C10.8198 1.83549 10.7245 1.875 10.625 1.875C10.4261 1.875 10.2353 1.95402 10.0947 2.09467C9.95402 2.23532 9.875 2.42609 9.875 2.625C9.875 2.72446 9.83549 2.81984 9.76517 2.89017C9.69484 2.96049 9.59946 3 9.5 3Z",
        fill: "white"
    }), /*#__PURE__*/ _react.createElement("path", {
        d: "M14.5 24C14.4005 24 14.3052 23.9605 14.2348 23.8902C14.1645 23.8198 14.125 23.7245 14.125 23.625C14.125 23.4261 14.046 23.2353 13.9053 23.0947C13.7647 22.954 13.5739 22.875 13.375 22.875C13.2755 22.875 13.1802 22.8355 13.1098 22.7652C13.0395 22.6948 13 22.5995 13 22.5C13 22.4005 13.0395 22.3052 13.1098 22.2348C13.1802 22.1645 13.2755 22.125 13.375 22.125C13.5739 22.125 13.7647 22.046 13.9053 21.9053C14.046 21.7647 14.125 21.5739 14.125 21.375C14.125 21.2755 14.1645 21.1802 14.2348 21.1098C14.3052 21.0395 14.4005 21 14.5 21C14.5995 21 14.6948 21.0395 14.7652 21.1098C14.8355 21.1802 14.875 21.2755 14.875 21.375C14.875 21.5739 14.954 21.7647 15.0947 21.9053C15.2353 22.046 15.4261 22.125 15.625 22.125C15.7245 22.125 15.8198 22.1645 15.8902 22.2348C15.9605 22.3052 16 22.4005 16 22.5C16 22.5995 15.9605 22.6948 15.8902 22.7652C15.8198 22.8355 15.7245 22.875 15.625 22.875C15.4261 22.875 15.2353 22.954 15.0947 23.0947C14.954 23.2353 14.875 23.4261 14.875 23.625C14.875 23.7245 14.8355 23.8198 14.7652 23.8902C14.6948 23.9605 14.5995 24 14.5 24Z",
        fill: "white"
    }), /*#__PURE__*/ _react.createElement("path", {
        d: "M4 9C3.82319 9 3.65362 8.92976 3.5286 8.80474C3.40357 8.67971 3.33333 8.51014 3.33333 8.33333C3.33333 7.62609 3.05238 6.94781 2.55228 6.44772C2.05219 5.94762 1.37391 5.66667 0.666667 5.66667C0.489856 5.66667 0.320286 5.59643 0.195262 5.4714C0.0702379 5.34638 0 5.17681 0 5C0 4.82319 0.0702379 4.65362 0.195262 4.5286C0.320286 4.40357 0.489856 4.33333 0.666667 4.33333C1.37391 4.33333 2.05219 4.05238 2.55228 3.55228C3.05238 3.05219 3.33333 2.37391 3.33333 1.66667C3.33333 1.48986 3.40357 1.32029 3.5286 1.19526C3.65362 1.07024 3.82319 1 4 1C4.17681 1 4.34638 1.07024 4.4714 1.19526C4.59643 1.32029 4.66667 1.48986 4.66667 1.66667C4.66667 2.37391 4.94762 3.05219 5.44772 3.55228C5.94781 4.05238 6.62609 4.33333 7.33333 4.33333C7.51014 4.33333 7.67971 4.40357 7.80474 4.5286C7.92976 4.65362 8 4.82319 8 5C8 5.17681 7.92976 5.34638 7.80474 5.4714C7.67971 5.59643 7.51014 5.66667 7.33333 5.66667C6.62609 5.66667 5.94781 5.94762 5.44772 6.44772C4.94762 6.94781 4.66667 7.62609 4.66667 8.33333C4.66667 8.51014 4.59643 8.67971 4.4714 8.80474C4.34638 8.92976 4.17681 9 4 9Z",
        fill: "white"
    }), /*#__PURE__*/ _react.createElement("path", {
        d: "M20 22C19.8232 22 19.6536 21.9298 19.5286 21.8047C19.4036 21.6797 19.3333 21.5101 19.3333 21.3333C19.3333 20.6261 19.0524 19.9478 18.5523 19.4477C18.0522 18.9476 17.3739 18.6667 16.6667 18.6667C16.4899 18.6667 16.3203 18.5964 16.1953 18.4714C16.0702 18.3464 16 18.1768 16 18C16 17.8232 16.0702 17.6536 16.1953 17.5286C16.3203 17.4036 16.4899 17.3333 16.6667 17.3333C17.3739 17.3333 18.0522 17.0524 18.5523 16.5523C19.0524 16.0522 19.3333 15.3739 19.3333 14.6667C19.3333 14.4899 19.4036 14.3203 19.5286 14.1953C19.6536 14.0702 19.8232 14 20 14C20.1768 14 20.3464 14.0702 20.4714 14.1953C20.5964 14.3203 20.6667 14.4899 20.6667 14.6667C20.6667 15.3739 20.9476 16.0522 21.4477 16.5523C21.9478 17.0524 22.6261 17.3333 23.3333 17.3333C23.5101 17.3333 23.6797 17.4036 23.8047 17.5286C23.9298 17.6536 24 17.8232 24 18C24 18.1768 23.9298 18.3464 23.8047 18.4714C23.6797 18.5964 23.5101 18.6667 23.3333 18.6667C22.6261 18.6667 21.9478 18.9476 21.4477 19.4477C20.9476 19.9478 20.6667 20.6261 20.6667 21.3333C20.6667 21.5101 20.5964 21.6797 20.4714 21.8047C20.3464 21.9298 20.1768 22 20 22Z",
        fill: "white"
    }));
}

//# sourceMappingURL=OutlineEdit.js.map